import React from 'react';
import One from '../layouts/one';
import Title from '../partials/title';
import { Animated } from 'react-animated-css';
import MedalCard from './partials/medal_card';
import { preload } from '../../helpers';
import _ from 'lodash';

class Passport extends React.Component {
    componentWillMount() {
        preload(this.props, true);
    }
    render() {
        const { medals } = this.props;
        const chunks = _.chunk(medals || [], 4);
        return (
            <One nbs="passport" bi="passport_medals.jpg">
                <section>
                    <div style={{ height: 600, zIndex: 1, }} className="d-flex flex-column justify-content-center">
                        <Animated animationIn="fadeInLeft" className="w-100 align-self-center w3-container w3-content" style={{ zIndex: 1 }}>
                            <h1 className="hero-text anton white text-left">PASSPORT</h1>
                            <p className="white hind">The Challenge Sports “Passport” is new for the 2019/2020 season. Each tournament will have a dedicated medal which participating players will get a stamp on their passport. Challenge Sports has created eight (8) different medals which represents historic or well-known parts of Florida.  If a player gets five (5) or more unique stamps on their Passport they will get a commemorative t-shirt which will be provided at Nationals. There are 4 different levels of t-shirts based on the number of stamps a player gets.  These levels are listed below. Passports will be available at all of our events. Good luck in your Tour travels and see you at the fields.</p>
                        </Animated>
                    </div>
                    <div className="w3-white">
                        <div className="d-flex flex-column w3-container w3-content pb-8 pt-8" style={{ marginTop: -100 }}>
                            {chunks.map((chunk, i) => (
                                <div className="d-flex row-column w-100" key={i}>
                                    {chunk.map((medal, j) => (
                                        <div className="w-100" key={j}>
                                            <MedalCard medal={medal} index={i * 4 + j} />
                                        </div>))}
                                </div>))}
                        </div>
                    </div>

                    <div className="bg-whiteish" style={{ position: 'relative', overflow: 'hidden' }}>
                        <div className="d-flex flex-row w3-container w3-content pb-8 pt-8">
                            <div className="w-100">
                                <img alt="" className="w-100" src="/images/others/explorer.jpg" />
                            </div>
                            <div style={{ width: 40 }} />
                            <div className="w-100 d-flex flex-column justify-content-start">
                                <Title text="EXPLORER - 5/8" />
                                <p className="gray hind margin-top">Players that receive 5 of the 8 possible stamps will reach explorer status. Congratulations this is no easy feat. Job well done.</p>
                            </div>
                        </div>
                        <span className="super-hero-text black anton w-100 text-right block" style={{ position: 'absolute', bottom: -100, opacity: 0.05, }}>FIRST</span>
                    </div>

                    <div className="bg-white" style={{ position: 'relative', overflow: 'hidden' }}>
                        <span className="super-hero-text black anton w-100 text-left block" style={{ position: 'absolute', bottom: -100, opacity: 0.05, }}>SECOND</span>
                        <div className="d-flex flex-row w3-container w3-content pb-8 pt-8" style={{ zIndex: 1 }}>
                            <div className="w-100 d-flex flex-column justify-content-start">
                                <Title text="GALLIVANTER - 6/8" />
                                <p className="gray hind margin-top">Players that receive 6 of 8 possible stamps will reach Gallivanter status.  Welcome to the club you have worked hard to receive this level. Feel honored as very few will ever achieve what you have.</p>
                            </div>
                            <div style={{ width: 40 }} />
                            <div className="w-100">
                                <img alt="" className="w-100" src="/images/others/gallivanter.jpg" />
                            </div>
                        </div>
                    </div>

                    <div className="bg-whiteish" style={{ position: 'relative', overflow: 'hidden' }}>
                        <div className="d-flex flex-row w3-container w3-content pb-8 pt-8">
                            <div className="w-100">
                                <img alt="" className="w-100" src="/images/others/jetsetter.jpg" />
                            </div>
                            <div style={{ width: 40 }} />
                            <div className="w-100 d-flex flex-column justify-content-start">
                                <Title text="JET SETTER - 7/8" />
                                <p className="gray hind margin-top">Players that receive 7 of 8 possible stamps will reach Jet Setter status. Your commitment and travels have paid off and earned you a rare status that most don’t achieve.  GREAT JOB</p>
                            </div>
                        </div>
                        <span className="super-hero-text black anton w-100 text-right block" style={{ position: 'absolute', bottom: -100, opacity: 0.05, }}>THIRD</span>
                    </div>

                    <div className="bg-white" style={{ position: 'relative', overflow: 'hidden' }}>
                        <span className="super-hero-text black anton w-100 text-left block" style={{ position: 'absolute', bottom: -100, opacity: 0.05, }}>FOURTH</span>
                        <div className="d-flex flex-row w3-container w3-content pb-8 pt-8" style={{ zIndex: 1 }}>
                            <div className="w-100 d-flex flex-column justify-content-start">
                                <Title text="GLOBE TROTTER - 8/8" />
                                <p className="gray hind margin-top">Players that receive 8 or 8 possible stamps will reach Globe Trotter status. AMAZING there are so few of you that your accomplishments are in a league of their own.  Your commitment to achieve this level has so many people admiring you. One of a kind!!!!!</p>
                            </div>
                            <div style={{ width: 40 }} />
                            <div className="w-100">
                                <img alt="" className="w-100" src="/images/others/globe.jpg" />
                            </div>
                        </div>
                    </div>

                </section>
            </One>
        );
    }
}

export default Passport;



// WEBPACK FOOTER //
// ./src/components/information/passport.js